import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

export type SuiBadgeVariant =
  | 'success'
  | 'danger'
  | 'warning'
  | 'neutral'
  | 'inactive'
  | 'info'
  | 'brand'
  | 'archived';

/**
 * Small status/tag lozenge - the single badge used by grid cells, detail
 * panels and dialogs (status, outcome, mode, tags). Display-only: text +
 * feedback variant, no interaction. Replaced the per-view copies
 * (harvest-log/http-log/data-provider/sitemap/remediation badges), so every
 * status and tag chip across the app shares this one recipe.
 *
 * The chip chrome sits on the host element itself (variant via the
 * `data-variant` hook), so a consumer can lay the badge out for its context
 * (e.g. a grid cell stretching it to full width) without piercing the
 * component - override display/flex/text-align on the `sui-badge` element,
 * never the chrome.
 */
@Component({
  selector: 'sui-badge',
  standalone: true,
  template: `{{ text }}`,
  host: { '[attr.data-variant]': 'variant' },
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sui-badge.component.scss',
})
export class SuiBadgeComponent {
  @Input() text = '';
  @Input() variant: SuiBadgeVariant = 'neutral';
}
